import { useEffect } from 'react';

export function useClickOutside(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var onClick = arguments[2];

  var els = [].concat(el);
  var active = true;

  if (!onClick && typeof options === 'function') {
    onClick = options;
  } else {
    active = options.active;
  }

  var handler = function handler(ev) {
    var target = ev.target;

    if (els.every(function (ref) {
      return !ref.current || !ref.current.contains(target);
    })) {
      onClick(ev);
    }
  };

  var cleanup = function cleanup() {
    return window.removeEventListener('click', handler);
  };

  useEffect(function () {
    if (active) {
      window.addEventListener('click', handler);
    } else {
      cleanup();
    }

    return cleanup;
  });
}